<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             title="新增工单"
             @open="open"
             @closed="closed"
             width="1000px">
    <el-tabs v-model="activeName" @tab-click="clickTab" style="height: 500px">
      <el-tab-pane name="basic">
        <template #label>
          <span style="padding: 0 50px; cursor: pointer">工单基本信息</span>
        </template>
        <basic-work-pane2 pattern="NEW" :work="work" ref="basicPane"></basic-work-pane2>
      </el-tab-pane>
      <el-tab-pane name="loss">
        <template #label>
          <span style="padding: 0 50px; cursor: pointer">维修信息</span>
        </template>
        <loss-determ-panel v-loading="work.basicPaintWorkHour === null" pattern="NEW" :loss-determ="work.lossDeterm"
                           :work="work"></loss-determ-panel>
      </el-tab-pane>
    </el-tabs>
    <template #footer>
      <el-button type="primary" @click="nextStep" v-show="activeName === 'basic'">下一步</el-button>
      <el-button type="primary" @click="lastStep" v-show="activeName === 'loss'">上一步</el-button>
      <el-button type="primary" @click="saveAndPrint" v-show="activeName === 'loss'" v-loading="saveLoading">保存并打印
      </el-button>
      <el-button type="primary" @click="save()" v-show="activeName === 'loss'" v-loading="saveLoading">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
    <div v-show="false">
      <el-button v-print="printTarget" ref="printTrigger"></el-button>
      <print-work id="printContent" :work="work" ref="print"></print-work>
    </div>
  </el-dialog>
</template>

<script>
  import { addWork, firstModel, getData } from '@/utils/request'
  import { Work } from '@/store/objdef/objectDef'
  import LossDetermPanel from '@/views/kanban/dialog/add-check/LossDetermPanel'
  import PrintWork from '@/views/kanban/dialog/add-check/PrintWork'
  import BasicWorkPane2 from '@/views/kanban/dialog/add-check/BasicWorkPane2'

  export default {
    name: 'AddWorkDialog',
    components: {
      BasicWorkPane2,
      PrintWork,
      LossDetermPanel
    },
    data () {
      return {
        activeName: 'basic',
        work: new Work(),
        printTarget: {
          id: 'printContent',
          popTitle: null
        },
        saveLoading: false
      }
    },
    methods: {
      hide () {
        this.$emit('update:visible', false)
      },
      clickTab () {
        if (this.activeName === 'basic') return

        this.workRef.validate(valid => {
          if (!valid) {
            this.$message.warning('请先完成基本信息填写')
            this.$nextTick(() => {
              this.activeName = 'basic'
            })
          }
        })
      },
      cancel () {
        this.hide()
      },
      nextStep () {
        this.workRef.validate(valid => {
          if (valid) {
            this.activeName = 'loss'
          }
        })
      },
      lastStep () {
        this.activeName = 'basic'
      },
      save (callback) {
        if (this.work.lossDeterm.partsList.length === 0) {
            this.$message.warning('请选择需要维修的部位')
            return
        }

        this.work.enterTime = new Date()
        if (this.saveLoading) return
        this.saveLoading = true

        this.work.carNo = this.work.carNo.trim()
        addWork(this.$_.cloneDeep(this.work)).then(response => {
          if (callback) {
            this.printTarget.popTitle = '工单：' + (response.data.extraId || response.data.id)
            this.work.consultantName = response.data.consultantName
            this.work.id = response.data.id
            callback()
          } else {
            this.hide()
          }
        }).finally(() => {
          this.saveLoading = false
        })
      },
      print () {
        this.$refs.printTrigger.$el.click()
      },
      saveAndPrint () {
        // 设置打印对话框关闭后关闭此窗口的回调
        this.printTarget.closeCallback = this.hide
        this.save(() => this.print())
      },
      open () {
        this.saveLoading = false
        this.work.carNo = this.$store.state.shop.carNoPrefix
        for (const brandId of this.$store.state.shop.carBandIds) {
          firstModel(brandId).then(response => {
            if (response.data) {
              this.work.brandModel = [brandId, response.data.name]
            }
          })
        }
        const insuranceCompanyIds = this.$store.state.shop.insuranceCompanyIds
        if (insuranceCompanyIds && insuranceCompanyIds.length > 0) {
          this.work.insuranceCompanyId = insuranceCompanyIds[0]
        }
        getData('basicPaintWorkHour').then(response => {
          this.work.basicPaintWorkHour = response.data
        })
      },
      closed () {
        this.activeName = 'basic'
        this.work = new Work()
        this.work.carNo = this.$store.state.shop.carNoPrefix
        this.workRef.resetFields()
      }
    },
    computed: {
      workRef () {
        return this.$refs.basicPane.$refs.work
      }
    }
  }
</script>
